import style from "./SwitchButton.module.scss";
import cn from "classnames";

export function SwitchButton({
  checked,
  onChecked,
  size = "small",
  disabled = false
}: {
  checked: boolean;
  onChecked: () => void;
  size?: "small" | "big";
  disabled?: boolean;
}) {
  return (
    <button
      type="button"
      className={cn(
        style.button,
        checked && style.active,
        size === "small" && style.small,
        size === "big" && style.big,
        disabled && 'opacity-50 cursor-not-allowed'
      )}
      onClick={onChecked}
      disabled={disabled}
    >
      <div className={style.innerСircle}></div>
    </button>
  );
}
